import getHashtagForInboxClassificationFilter from './getHashtagForInboxClassificationFilter';
import inboxPlusStore from '../store/Store';
import InboxClassificationFilterHashtag from '../store/schema/InboxClassificationFilterHashtag';
import InboxClassificationFilter from '../store/schema/InboxClassificationFilter';
import { isInboxPlusEnabled } from './inboxPlusFlightUtil';

export default function getHashtagsToExclude(
    inboxClassificationFilter: InboxClassificationFilter
): InboxClassificationFilterHashtag[] {
    if (!isInboxPlusEnabled()) {
        return null;
    }

    switch (inboxClassificationFilter) {
        case InboxClassificationFilter.Focused:
        case InboxClassificationFilter.Other:
            return getHashtagsToExcludeForFocusedOtherPivots();
        default:
            return [];
    }
}

function getHashtagsToExcludeForFocusedOtherPivots(): InboxClassificationFilterHashtag[] {
    const hashtagsToExclude = [];
    const allPivots = inboxPlusStore.inboxPlusPivots;

    for (const pivot of allPivots) {
        // Logic for hashtagsToExclude in the Focused/Other pivots
        // We want to exclude hashtags for non Focused/Other pivots (e.g. promotions, social, newsletters) that are currently enabled, since those pivots will contain the messages
        if (
            pivot.InboxClassificationFilter != InboxClassificationFilter.None &&
            pivot.InboxClassificationFilter != InboxClassificationFilter.Focused &&
            pivot.InboxClassificationFilter != InboxClassificationFilter.Other &&
            pivot.isEnabled
        ) {
            hashtagsToExclude.push(
                getHashtagForInboxClassificationFilter(pivot.InboxClassificationFilter)
            );
        }
    }
    return hashtagsToExclude;
}
